/**
 * Asynchronously loads the component for ActivityBuilderContainer
 */
import React, { Suspense } from 'react';
import Spinner from 'components/FullScreenSpinner';

const ActivityBuilderContainer = React.lazy(() => import('./index'));

export default function Loadable(props) {
  return (
    <Suspense fallback={<Spinner />}>
      <ActivityBuilderContainer {...props} />
    </Suspense>
  );
}
